import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Classes, DISPLAYNAME_PREFIX } from "../../common";

const propTypes = {
    //tag: tagPropType,
    fluid: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    className: PropTypes.string,
    children: PropTypes.node,
    //cssModule: PropTypes.object,
};

const defaultProps = {
    //tag: "div",
};

type Props = React.PropsWithChildren<{
    className?: string;
    //cssModule?: string;
    fluid?: boolean;
}>;

const Container = (props: Props) => {
    const { className, /*cssModule,*/ fluid, /*tag: Tag,*/ ...attributes } = props;

    let containerClass = Classes.GRID_CONTAINER;
    if (fluid === true) {
        containerClass = Classes.GRID_CONTAINER_FLUID;
    } else if (fluid) {
        containerClass = `${Classes.GRID_CONTAINER}-${fluid}`;
    }

    const classes = classNames(className, containerClass);

    return <div {...attributes} className={classes} />;
    //return <Tag {...attributes} className={classes} />;
};

Container.propTypes = propTypes;
Container.defaultProps = defaultProps;
Container.displayName = `${DISPLAYNAME_PREFIX}.Container`;

export { Container };
